module.exports = __webpack_public_path__ + "img/仓鼠.ec179d4e.gif";